import React, { Component } from 'react';
import './muscomunicadoEn.css';
import { Col, Container, Row, Button, Card } from 'react-bootstrap';

/*Import custom Components */
import MailChimp from '../../../../Componentes/MailChimp/MailChimp';
import SocialShare from '../../../../Componentes/SocialShare/SocialShare';

/*import assets */
import IconArrow from '../../../../assets/img/icon-row-right.svg';
// import IconFB from '../../../../../assets/img/ico-social/ico-fb.svg';
// import IconIn from '../../../../../assets/img/ico-social/ico-in.svg';
// import IconTwt from '../../../../../assets/img/ico-social/ico-twt.svg';
// import IconInsta from '../../../../../assets/img/ico-social/ico-insta.svg';

/*Import Images Feed */
import FeaturedImage from '../../../../assets/img/img-comunicados/ditobanxMUS.jpg';
import IconBuzon from '../../../../assets/img/icon-buzon.svg';
//import Profile from '../../../../../assets/img/img-comunicados/ditobanx-mastercard.png';


export default class MusComunicadoEn extends Component {
    render() {
        const urlLocation = window.location.href;
        return (
            <>
                <div className='mt-5 pt-4'></div>
                <Container fluid style={{ backgroundColor: '#EFEFEF' }} className='pt-4'>
                    <Container>
                        <Row className='py-4'>
                            <Col className='col-12 col-md-8 rounded-3 shadow-sm p-3 mb-3 mb-md-5 bg-body pt-0'>
                                <div className="row justify-content-between border-bottom py-3">
                                    <div className="col-12 col-md-6 d-flex">
                                        <a href={'/noticias-prensa'} className='text-decoration-none'>
                                            <img  src={IconArrow} alt='' width={22} className='mb-2  '  />
                                            <span className='px-2 h1-custom'>Comunicados de prensa</span>
                                        </a>
                                    </div>
                                    <div className="col-12 col-md-6 text-end d-md-inline d-none">
                                        <SocialShare
                                            PostUrl={urlLocation}
                                            TwitterTitle="Innovation Meets Regulation: DitoBanx Achieves Major Milestone with US Money Service Business Registration "
                                            LinkedInTitle="Innovation Meets Regulation: DitoBanx Achieves Major Milestone with US Money Service Business Registration "
                                            Size="32px"
                                            className="d-none"

                                        />
                                    </div>
                                </div>
                                <Col className='py-3 col-12 px-2'>
                                    <Button variant="outline-dark rounded-pill fw-bold border-2 f-bange-custom">NOTICIAS BITCOIN</Button>
                                    <span className='mx-2 color-custom-date'>El Salvador,FEBRUARY 3, 2024</span>
                                </Col>
                                <Col className="mb-3 mx-2" style={{marginBottom:'4rem'}}>
                                    <img src={FeaturedImage} className="custom-featured-image img-fluid rounded-3 custom-featured-imageGf" alt='DitoBanx MUS US' />
                                    
                                </Col>
                                <Col className="mb-3 mx-2">
                                <div className='color-custom-date py-1 px-3 border-bottom'>Image created by Team Ditobanx</div>
                                </Col>
                                
                                <Col>
                                    <h1 className='fw-bold lh-1 pb-2 px-2'>Innovation Meets Regulation: DitoBanx Achieves Major Milestone with US Money Service Business Registration 
                                    </h1>
                                    <span className='fw-bold px-2'>By DitoBanx</span>
                                </Col>
                                <Col className="py-3 px-2">
                                    {/* <img src={Profile} style={{ width: '18.2rem' }} className="d-block pe-3 text-center mx-auto float-center float-md-start rounded-3 pb-3 pb-md-0" alt='itoBanx,  startup en servicios Bitcoin, se constituye como la primera Fintech salvadoreña en lograr fondos de inversión por medio millón de dólares' /> */}
                                    <p className='lh-sm text-justify'>
                                    Wyoming, <strong>Feb 3rd 2024</strong> — In a significant milestone that marks a new era of financial services in the Americas, DitoBanx, the innovative fintech company, is thrilled to announce its recent achievement of receiving the Money Service Business (MSB) registration in the United States. This pivotal registration enables DitoBanx to officially operate as a Money Transmitter and Remittance Processor, offering secure, efficient, and reliable financial solutions across borders.
                                    <br/><br/>
                                    Guillermo Contreras, CEO of DitoBanx, expressed his excitement about the achievement, <span  style={{fontStyle: 'italic'}}>"This registration is not just a milestone; it's a testament to our commitment to providing top-notch financial services while ensuring the utmost security and compliance with regulatory standards. It's a significant step forward in our mission to revolutionize financial transactions in the Americas and beyond."</span>
                                     <br/><br/>
                                     This strategic achievement is part of DitoBanx's broader vision to expand its footprint and influence across the Americas. The MSB registration is a cornerstone in DitoBanx's ambitious strategic plan, laying the groundwork for a suite of innovative financial services designed to meet the evolving needs of customers in an increasingly digital and interconnected world.
                                     <br/><br/>
                                     <strong>The Future of Financial Transactions</strong>
                                     <br/><br/>
                                     With this registration, DitoBanx is set to roll out a range of services that promise to redefine the way people and businesses transact across borders. From seamless remittances to efficient money transfers, DitoBanx is poised to become a leading player in the financial services sector, offering solutions that are not only convenient but also highly secure.
                                     <br/><br/>
                                     <strong>A Commitment to Compliance and Security</strong>
                                     <br/><br/>
                                     DitoBanx's achievement of the MSB registration underscores its commitment to compliance with U.S. regulations, ensuring that its operations meet the highest standards of security and integrity. This commitment is at the core of DitoBanx's operations, providing customers with peace of mind and trust in the company's services.
                                     <br/><br/>

                                     
                                                               
                                    </p>
                                </Col>
                                
                                <Col>
                                    <h3 className='fs-5'><strong>About DitoBanx</strong> </h3>
                                    <p className='lh-sm text-justify'>
                                    DitoBanx is a pioneering fintech company dedicated to transforming financial services through innovation, security, and efficiency. With a focus on money transmission and remittance processing, DitoBanx aims to bridge the gap between traditional financial systems and the digital economy, making financial transactions faster, safer, and more accessible to people across the Americas.</p>
                                    <br></br>
                                    <br/><br/>
                                    <p className='lh-sm text-justify'>
                                    For further information, please contact:
                                    </p>
                                </Col>
                                
                                <br/>
                                <Col>
                                    <span> DitoBanx</span><br/>
                                    <span> public-relations@ditobanx.com</span><br/>
                                    <span>  <a style={{color:'#f7931a'}} href={'https://www.ditobanx.com'} target="_blank" rel="noreferrer" >www.ditobanx.com </a> </span><br/>
                                    
                                </Col>
                                <Card className='px-2 pt-4 pb-4 bg-card-custom border-0'>
                                    <Row>
                                        <Col>
                                            <Card.Body className='pt-0'>
                                                <Card.Title className="mb-0 text-center text-md-start">Equipo DitoBanx</Card.Title>
                                                <span className='d-block text-center text-md-start fw-bold'>Noticias</span>
                                                <Card.Text className='d-none lh-1 d-block text-center text-md-start'>
                                                    Presentadora
                                                </Card.Text>
                                            </Card.Body>
                                        </Col>
                                        <Col className='col-12 col-md-3 vertical-align-custom pe-4'>
                                            <div className="col text-center tex-md-end">
                                                <SocialShare
                                                    PostUrl={urlLocation}
                                                    TwitterTitle="DitoBanx enhances the financial market in El Salvador and launches a digital wallet that allows consumers to spend their cryptocurrencies"
                                                    LinkedInTitle="DitoBanx enhances the financial market in El Salvador and launches a digital wallet that allows consumers to spend their cryptocurrencies"
                                                    Size="32px"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col className='col-12 col-md-3 px-0 px-md-0 ms-0 ms-md-4'>
                                <Card className='vertical-align-custom rounded-3 shadow-sm mb-5 bg-body border-0 pt-5'>
                                    <img alt='' src={IconBuzon} width={64} />
                                    <Card.Body>
                                        <Card.Title className='fw-bold text-center'>Mantente informado</Card.Title>
                                        <Card.Text className='lh-1 text-center '>
                                            Suscríbase para obtener un resumen de nuestras últimas noticias y boletines informativos.
                                            <MailChimp />
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </>
        )
    }
}
